module.exports = __webpack_public_path__ + "img/chevron-down-solid.8f27fb2b.svg";